/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ReportGenerationStateRepresentation } from '@veeam-vspc/models/web-controllers';
import { useGlobalAddons, useGlobalLang } from '@veeam-vspc/shared/components';

import type { VspcLang } from 'configs/languages';

import { StatusColumn } from 'views/components/columns/StatusColumn';
import { StatusTypes } from 'core/utils/status-helpers/enums';

interface InvoiceConfigurationStatusColumnProps {
    exceptions?: string;
    status: ReportGenerationStateRepresentation;
}

function getStatus(status: ReportGenerationStateRepresentation) {
    switch (status) {
        case ReportGenerationStateRepresentation.Successed:
            return StatusTypes.Success;
        case ReportGenerationStateRepresentation.Processed:
            return StatusTypes.Pending;
        case ReportGenerationStateRepresentation.Unknown:
            return '';
        default:
            return status;
    }
}

export const InvoiceConfigurationStatusColumn: React.FC<InvoiceConfigurationStatusColumnProps> = ({ status, exceptions }) => {
    const lang = useGlobalLang<VspcLang>();
    const { portalEnums } = useGlobalAddons();

    return (
        <StatusColumn
            status={getStatus(status)}
            isLink
            isTextHidden
            content={portalEnums.getEnumDescription('ReportGenerationStateRepresentation', status)}
            messageBoxTitle={lang.STATUS}
            message={exceptions}
        />
    );
};
